import React from 'react';
import styled from 'styled-components';
import {Box} from '@material-ui/core';

export const Background = styled(Box)`
  overflow: hidden;
  justify-content: center;
  border-radius: 16px;
  background-color: #FFFFFF;
  box-shadow: 0 3px 16px 0 rgba(0,0,0,0.07);
  padding: 30px;
`;

const ContentContainer = styled(Box)`
  margin: 10px;
`;

// Only needed to passthrough data-id
export const AppBackground = (props: React.PropsWithChildren<any>) => {
    return <ContentContainer>
        <Background {...props} data-testid={'AppBackground'}/>
    </ContentContainer>;
};
